import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import InputHtmlRenderer from './Renderer/InputHtmlRenderer';
const InputControls = lazyLoad(() => import('./Controls/InputControls'));
export default (settings) => {
    const plugin = createPlugin(Object.assign({ Controls: InputControls, Renderer: InputHtmlRenderer }, settings));
    return plugin;
};
//# sourceMappingURL=index.js.map